type TeamChartLegendItemProps = {
  color: string;
  name: string;
};

export function TeamChartLegendItem({ color, name }: TeamChartLegendItemProps) {
  return (
    <div className="flex items-center gap-2">
      <span
        className="h-2.5 w-2.5 shrink-0 rounded-[2px]"
        style={{ backgroundColor: color }}
        aria-hidden
      />
      <div className="flex min-w-0 flex-1 items-center gap-4 leading-none">
        <span className="text-muted-foreground">{name}</span>
      </div>
    </div>
  );
}
